import {
  Badge,
  Button,
  Center,
  Flex,
  Heading,
  Stack,
  Text,
  WrapItem,
} from '@chakra-ui/react';
import CaptionCarousel from './Carousel';
import { cards } from './cards';

export default function ProjectsCard() {
  return (
    <>
      {cards.map((card, i) => {
        return (
          <div key={i}>
            <Center p={5}>
              <Stack
                borderWidth="1px"
                borderRadius="lg"
                width={{ sm: '450px', md: '450px', lg: '450px' }}
                height={{ sm: '23rem', md: '23rem', lg: '23rem' }}
                direction={{ base: 'row', md: 'row', lg: 'row' }}
                boxShadow={'2xl'}
                padding={4}
              >
                <Flex
                  flex={1}
                  bg="transparent"
                  width={{ sm: '15rem', md: '15rem', lg: '15rem' }}
                >
                  <CaptionCarousel images={card.image} alt={card.title} />
                </Flex>
                <Stack
                  flex={1}
                  flexDirection="column"
                  justifyContent="center"
                  alignItems="center"
                  p={1}
                  pt={2}
                >
                  <Heading
                    fontSize={{ sm: 'xl', md: '2xl', lg: '2xl' }}
                    fontFamily={'body'}
                    color={'#04798a'}
                  >
                    {card.title}
                  </Heading>
                  <Text
                    fontWeight={600}
                    color={'gray.500'}
                    fontSize={{ sm: 'xs', md: 'sm', lg: 'sm' }}
                    mb={4}
                  >
                    {card.description}
                  </Text>

                  <WrapItem>
                    <Stack
                      align={'center'}
                      justify={'center'}
                      direction={'row'}
                      wrap={'wrap'}
                      mt={4}
                    >
                      {card.tools.map((tool, i) => {
                        return (
                          <div key={i}>
                            <Badge
                              px={2}
                              py={1}
                              mr={2}
                              mb={2}
                              fontWeight={'400'}
                              fontSize={'0.65rem'}
                            >
                              {tool}
                            </Badge>
                          </div>
                        );
                      })}
                    </Stack>
                  </WrapItem>

                  <Stack
                    width={'100%'}
                    mt={'2rem'}
                    direction={'row'}
                    padding={2}
                    justifyContent="center"
                    alignItems="center"
                  >
                    <a href={card.code} target="_blank" rel="noreferrer">
                      <Button
                        flex={1}
                        fontSize={'sm'}
                        rounded={'full'}
                        bg={'#ffffffd0'}
                        color={'gray.600'}
                      >
                        Code
                      </Button>
                    </a>
                  </Stack>
                </Stack>
              </Stack>
            </Center>
          </div>
        );
      })}
    </>
  );
}
